import { Env } from 'app/ssr/compose-script-tags/global';

export const getUniversalEnv = (envName: keyof Env) => {
  if (typeof window !== 'undefined' && '__env' in window) {
    return window.__env[envName];
  }

  return process.env[envName];
};
